import { NgModule }                               from '@angular/core';
import { CommonModule }                           from "@angular/common";
import { FormsModule }                            from '@angular/forms';

import { IconAddressCardComponent }               from './icon-address-card-component';
import { IconAngleDoubleRightComponent }          from './icon-angle-double-right-component';
import { IconAngleDoubleLeftComponent }           from './icon-angle-double-left-component';
import { IconAngleLeftComponent }                 from './icon-angle-left-component';
import { IconAngleRightComponent }                from './icon-angle-right-component';
import { IconArrowsComponent }                    from './icon-arrows-component';
import { IconBanComponent }                       from './icon-ban-component';
import { IconBarChartComponent }                  from './icon-bar-chart-component';
import { IconBarsComponent }                      from './icon-bars-component';
import { IconBellComponent }                      from './icon-bell-component';
import { IconBellOComponent }                     from './icon-bell-o-component';
import { IconCalendarComponent }                  from './icon-calendar-component';
import { IconCalendarCheckComponent }             from './icon-calendar-check-component';
import { IconCalendarClockComponent }             from './icon-calendar-clock-component';
import { IconCaretDownComponent }                 from './icon-caret-down-component';
import { IconCheckComponent }                     from './icon-check-component';
import { IconCheckSquareOComponent }              from './icon-check-square-o-component';
import { IconCloudComponent }                     from './icon-cloud-component';
import { IconClockComponent }                     from './icon-clock-component';
import { IconColumnResizeComponent }              from './icon-column-resize-component';
import { IconCogsComponent }                      from './icon-cogs-component';
import { IconCollapseAllComponent }               from './icon-collapse-all-component';
import { IconCubesComponent }                     from './icon-cubes-component';
import { IconDownArrowComponent }                 from './icon-down-arrow-component';
import { IconEllipsisHComponent }                 from './icon-ellipsis-h-component';
import { IconEllipsisVComponent }                 from './icon-ellipsis-v-component';
import { IconEnvelopeComponent }                  from './icon-envelope-component';
import { IconEraserComponent }                    from './icon-eraser-component';
import { IconExclamationCircleComponent }         from './icon-exclamation-circle-component';
import { IconExclamationTriangleComponent }       from './icon-exclamation-triangle-component';
import { IconExcelComponent }                     from './icon-excel-component';
import { IconExchangeComponent }                  from './icon-exchange-component';
import { IconExpandAllComponent }                 from './icon-expand-all-component';
import { IconFileTextComponent }                  from './icon-file-text-component';
import { IconFileTextOComponent }                 from './icon-file-text-o-component';
import { IconFilesOComponent }                    from './icon-files-o-component';
import { IconFilterComponent }                    from './icon-filter-component';
import { IconFolderOpenComponent }                from './icon-folder-open-component';
import { IconGearComponent }                      from './icon-gear-component';
import { IconHomeComponent }                      from './icon-home-component';
import { IconInfoCircleComponent }                from './icon-info-circle-component';
import { IconKeyComponent }                       from './icon-key-component';
import { IconLeftArrowComponent }                 from './icon-left-arrow-component';
import { IconLevelDownComponent }                 from './icon-level-down-component';
import { IconLineChartComponent }                 from './icon-line-chart-component';
import { IconLinkComponent }                      from './icon-link-component';
import { IconLongArrowDownComponent }             from './icon-long-arrow-down-component';
import { IconLongArrowUpComponent }               from './icon-long-arrow-up-component';
import { IconLostConnectionComponent }            from './icon-lost-connection-component';
import { IconMailForwardComponent }               from './icon-mail-forward-component';
import { IconPauseComponent }                     from './icon-pause-component';
import { IconPendingComponent }                   from './icon-pending-component';
import { IconPencilComponent }                    from './icon-pencil-component';
import { IconPieChartComponent }                  from './icon-pie-chart-component';
import { IconPlayComponent }                      from './icon-play-component';
import { IconPlusComponent }                      from './icon-plus-component';
import { IconQuestionCircleComponent }            from './icon-question-circle-component';
import { IconRefreshComponent }                   from './icon-refresh-component';
import { IconRightArrowComponent }                from './icon-right-arrow-component';
import { IconRunningComponent }                   from './icon-running-component';
import { IconSearchComponent }                    from './icon-search-component';
import { IconSearchMinusComponent }               from './icon-search-minus-component';
import { IconSearchPlusComponent }                from './icon-search-plus-component';
import { IconShieldComponent }                    from './icon-shield-component';
import { IconSortAmountAscComponent }             from './icon-sort-amount-asc-component';
import { IconSortAmountDescComponent }            from './icon-sort-amount-desc-component';
import { IconStarComponent }                      from './icon-star-component';
import { IconStopCircleComponent }                from './icon-stop-circle-component';
import { IconThComponent }                        from './icon-th-component';
import { IconTimesCircleComponent }               from './icon-times-circle-component';
import { IconTimesComponent }                     from './icon-times-component';
import { IconTrainComponent }                     from './icon-train-component';
import { IconUpArrowComponent }                   from './icon-up-arrow-component';
import { IconUserCircleComponent }                from './icon-user-circle-component';
import { IconWindowMaximizeComponent }            from './icon-window-maximize-component';
import { IconWindowMinimizeComponent }            from './icon-window-minimize-component';
import { IconWindowRestoreComponent }             from './icon-window-restore-component';

@NgModule({
    imports: [ 
        CommonModule, 
        FormsModule,
    ],
    declarations: [
        IconAddressCardComponent,
        IconAngleDoubleLeftComponent,
        IconAngleDoubleRightComponent,
        IconAngleLeftComponent,
        IconAngleRightComponent,
        IconArrowsComponent,
        IconBanComponent,
        IconBarChartComponent,
        IconBarsComponent,
        IconBellComponent,
        IconBellOComponent,
        IconCalendarComponent,
        IconCalendarCheckComponent,
        IconCalendarClockComponent,
        IconCaretDownComponent,
        IconCheckComponent,
        IconCheckSquareOComponent,
        IconClockComponent,
        IconCloudComponent,
        IconCogsComponent,        
        IconCollapseAllComponent,
        IconColumnResizeComponent,
        IconCubesComponent,
        IconDownArrowComponent,
        IconEllipsisHComponent,        
        IconEllipsisVComponent,
        IconEnvelopeComponent,
        IconEraserComponent,
        IconExchangeComponent,
        IconExclamationCircleComponent,
        IconExclamationTriangleComponent,
        IconExpandAllComponent,
        IconExcelComponent,
        IconFileTextComponent,
        IconFileTextOComponent,
        IconFilesOComponent,
        IconFilterComponent,
        IconFolderOpenComponent,
        IconGearComponent,
        IconHomeComponent,
        IconInfoCircleComponent,
        IconKeyComponent,
        IconLeftArrowComponent,
        IconLevelDownComponent,
        IconLineChartComponent,
        IconLinkComponent,
        IconLongArrowDownComponent,
        IconLongArrowUpComponent,
        IconLostConnectionComponent,
        IconMailForwardComponent,
        IconPauseComponent,
        IconPencilComponent,
        IconPendingComponent,
        IconPieChartComponent,
        IconPlayComponent,
        IconPlusComponent,
        IconQuestionCircleComponent,
        IconRefreshComponent,
        IconRightArrowComponent,
        IconRunningComponent,
        IconSearchComponent,
        IconSearchMinusComponent,
        IconSearchPlusComponent,
        IconShieldComponent,
        IconSortAmountAscComponent,
        IconSortAmountDescComponent,
        IconStarComponent,
        IconStopCircleComponent,
        IconThComponent,
        IconTimesCircleComponent,
        IconTimesComponent,
        IconTrainComponent,
        IconUpArrowComponent,
        IconUserCircleComponent,
        IconWindowMaximizeComponent,
        IconWindowMinimizeComponent,
        IconWindowRestoreComponent
    ],
    exports: [ 
        IconAddressCardComponent,
        IconAngleDoubleLeftComponent,
        IconAngleDoubleRightComponent,
        IconAngleLeftComponent,
        IconAngleRightComponent,
        IconArrowsComponent,
        IconBanComponent,
        IconBarChartComponent,
        IconBarsComponent,
        IconBellComponent,
        IconBellOComponent,        
        IconCalendarComponent,
        IconCalendarCheckComponent,
        IconCalendarClockComponent,
        IconCaretDownComponent,
        IconCheckComponent,
        IconCheckSquareOComponent,
        IconClockComponent,
        IconCloudComponent,
        IconCogsComponent,
        IconCollapseAllComponent,
        IconColumnResizeComponent,
        IconCubesComponent,
        IconDownArrowComponent,
        IconEllipsisHComponent,
        IconEllipsisVComponent,
        IconEnvelopeComponent,
        IconEraserComponent,
        IconExchangeComponent,
        IconExclamationCircleComponent,
        IconExclamationTriangleComponent,
        IconExcelComponent,
        IconExpandAllComponent,
        IconFileTextComponent,
        IconFileTextOComponent,
        IconFilesOComponent,
        IconFilterComponent,
        IconFolderOpenComponent,
        IconGearComponent,
        IconHomeComponent,
        IconInfoCircleComponent,
        IconKeyComponent,
        IconLeftArrowComponent,
        IconLevelDownComponent,
        IconLineChartComponent,
        IconLinkComponent,
        IconLongArrowDownComponent,
        IconLongArrowUpComponent,
        IconLostConnectionComponent,
        IconMailForwardComponent,
        IconPauseComponent,
        IconPencilComponent,
        IconPendingComponent,
        IconPieChartComponent,
        IconPlayComponent,
        IconPlusComponent,
        IconQuestionCircleComponent,
        IconRefreshComponent,
        IconRightArrowComponent,
        IconRunningComponent,
        IconSearchComponent,
        IconSearchMinusComponent,
        IconSearchPlusComponent,
        IconShieldComponent,
        IconSortAmountAscComponent,
        IconSortAmountDescComponent,
        IconStarComponent,
        IconStopCircleComponent,
        IconThComponent,
        IconTimesCircleComponent,
        IconTimesComponent,
        IconTrainComponent,
        IconUpArrowComponent,
        IconUserCircleComponent,
        IconWindowMaximizeComponent,
        IconWindowMinimizeComponent,
        IconWindowRestoreComponent
    ],
})
export class IconsModule { 

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icons-module.ts